import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalScrollableContainer,
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableBody,
} from '../../../../components/modal';
import { Connect, PropsFromRedux } from './SearchFiltersOthersModalContainer';
import styles from './search_filters_others_modal.module.scss';
import { CommonSection } from '../../aside-filters/CommonSection';
import { Categories } from '../../aside-filters/categories/Categories';
import { Exclude } from '../../aside-filters/exclude/Exclude';
import { Parties } from '../../aside-filters/parties/Parties';
import { searchConstants } from '../../../search-utils/searchConstants';

type Props = {
  onRequestClose: () => void;
  isOpen: boolean;
} & PropsFromRedux;

const RawSearchFiltersOthersModal: FC<Props> = ({
  isOpen,
  onRequestClose,
  shouldDisplayVille,
  shouldDisplayPubli,
  shouldDisplaySolution,
}) => {
  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalScrollableHeader
        title={<FormattedMessage id="SearchFiltersOthersModal/title" />}
        onClose={onRequestClose}
      />
      <ModalScrollableContent>
        <ModalScrollableBody>
          <div className={styles.container}>
            {shouldDisplayVille && (
              <CommonSection title={searchConstants.filters.domaine}>
                <Categories type="ville" />
              </CommonSection>
            )}

            <Exclude />

            {shouldDisplayPubli && (
              <CommonSection title={searchConstants.filters.publi}>
                <Categories type="publi" />
              </CommonSection>
            )}

            {shouldDisplaySolution && (
              <CommonSection title={searchConstants.filters.solution}>
                <Categories type="solution" />
              </CommonSection>
            )}

            <Parties />
          </div>
        </ModalScrollableBody>
      </ModalScrollableContent>
    </ModalScrollableContainer>
  );
};

export const SearchFiltersOthersModal = Connect(RawSearchFiltersOthersModal);
